import type { FC } from 'react';
import { Checkbox as MuiCheckbox, FormControlLabel, Typography, } from '@mui/material';

interface GroupByHypothesisToggleProps {
  checked: boolean;
  onChange: (val: boolean) => void;
  label?: string;
}

const GroupByHypothesisToggle: FC<GroupByHypothesisToggleProps> = ({
  checked,
  onChange,
  label = 'Group by hypothesis',
}) => {
  return (
    <FormControlLabel
      control={
        <MuiCheckbox
          disabled
          checked={checked}
          onChange={(e) => { onChange(e.target.checked); }}
          size="small"
        />
      }
      label={<Typography variant="body2">{label}</Typography>}
    />
  );
};

export default GroupByHypothesisToggle;
